import React, {PureComponent} from 'react';
import {Route, Redirect, NavLink, Link} from 'react-router-dom';
import {Intent, PopoverInteractionKind, Position, Popover, Switch} from '@blueprintjs/core/lib/esm/index';
import toastr from 'toastr';


import {getCurrentUserId, getCurrentUserName, getJwt} from '../../../services/authService';
// import ReactGA from 'react-ga';
import http from '../../../services/httpService';
import countries from '../../common/countries';
import InputRegular from '../../common/InputRegular';

import AddPaymentMethodModal from '../../modals/AddPaymentMethodModal';
import PayPhoneNumbersResultModal from '../../modals/PayPhoneNumbersResultModal';
import ProPlanSuccessModal from '../../modals/ProPlanSuccessModal';
import ChartLoader from '../../utils/chart-loader';
import SinglePaymentMethod from '../billing/SinglePaymentMethod';
import SinglePaymentMethodSelect from '../billing/SinglePaymentMethodSelect';
import OrderSummary from './OrderSummary';
import RetinaImage from "react-retina-image";

//import {StripeProvider} from 'react-stripe-elements';


class ExistingPayment extends PureComponent {

    state = {
        loader: false,
        payPhoneNumbers: false,
        fundsAmount: 0,
        paymentMethods: [],
        selectedPaymentMethod: '',
        proPlanSuccessModalActive: false,
        paymentErrorMessage: '',
        stripePlanId: '',
        addedNumbers: [],
        boughtNumbers: [],
        notBoughtNumbers: [],
        notBoughtNumbersAmount: 0,
        payPhoneNumbersResultModalVisible: false,
        yearlySubscription: false,
        freeTrial: false,
        listOfEuAbbreviations: ['BE', 'BG', 'CZ', 'DK', 'DE', 'EE', 'IE', 'EL', 'ES', 'FR', 'GR', 'HR', 'IT', 'CY', 'LV',
            'LT', 'LU', 'HU', 'MT', 'NL', 'AT', 'PL', 'PT', 'RO', 'SI', 'SK', 'FI', 'SE', 'UK', 'GB'],
        shouldAddVat: false,
        noProjectPaymentMethods: false,
        discountCode: '',
        discountedAmount: this.props.discountedAmount ? this.props.discountedAmount : '',
        upcomingSwitchPlans: '',
        showDiscountInput: false,
        fieldsCheckActive: false,
        couponLoader: false,
        confirmed_promo_code: '',
        confirmed_promo_code_percentage: '',
        viberSelectedPlan: '',
        viberSelectedPlanId: '',
        autoTopUp: true,
        topUpLimit: 20,
        topUpWith: 50,
        errorsList: []
    };


    analytics = () => {
        // ReactGA.set({userId: getCurrentUserId()});
        // ReactGA.pageview(window.location.pathname + window.location.search);
    };

    getPaymentMethods = async () => {
        this.setState({ getPaymentMethodsLoader: true })
        let user = await this.props.user;
        let projectId = await this.props.selectedSource ? this.props.selectedSource : localStorage.source_clicked ? JSON.parse(localStorage.source_clicked) : '';

        let default_payment_method_for_project = '';

        if (user && user.customer && projectId) {
            /*GET PAYMENT METHODS PROJECT*/
            try {
                const result = await http.get('/api/user/' + user.id + '/project/' + projectId + '/customers/get_payment_methods_project', {headers: {authorization: getJwt()}});
                // console.log('Payment Methods: ', result.data, result.data.project_payment_methods.length);

                if (result.data.project_payment_methods.length) {
                    await result.data.project_payment_methods.map((method, index) => method.project_default ? default_payment_method_for_project = {
                        id: method.id,
                        payment_method_id: method.payment_method_id,
                        payment_method_country: method && method.billing_details && method.billing_details.address && method.billing_details.address.country ? method.billing_details.address.country : '',
                        payment_method_vat: method && method.billing_details && method.billing_details.vat_number ? method.billing_details.vat_number : '',
                    } : '')
                    await this.setState({paymentMethods: result.data.project_payment_methods})
                    // console.log('paymentMethods: ', this.state.paymentMethods)
                } else {
                    await this.setState({
                        paymentMethods: result.data.user_payment_methods,
                        noProjectPaymentMethods: true
                    })
                }
                // console.log('default_payment_method: ', default_payment_method_for_project)
                if (!this.state.selectedPaymentMethod || (default_payment_method_for_project.id !== this.state.selectedPaymentMethod.id) ) {
                    // This two ids are different, one is regular id, other is used for payment calls
                    let country = default_payment_method_for_project && default_payment_method_for_project.payment_method_country ?
                        await default_payment_method_for_project.payment_method_country
                        :
                        await result.data.user_payment_methods.length && result.data.user_payment_methods[0].billing_details &&
                        result.data.user_payment_methods[0].billing_details.address && result.data.user_payment_methods[0].billing_details.address.country ?
                            result.data.user_payment_methods[0].billing_details.address.country : '';

                    let vatNumber = default_payment_method_for_project &&
                    (default_payment_method_for_project.payment_method_vat || (default_payment_method_for_project.payment_method_vat === '')) ?
                        await default_payment_method_for_project.payment_method_vat
                        :
                        await result.data.user_payment_methods.length && result.data.user_payment_methods[0].billing_details &&
                        result.data.user_payment_methods[0].billing_details.vat_number ?
                            result.data.user_payment_methods[0].billing_details.vat_number : '';

                    // console.log('Existing Payment country: ', country)

                    let shouldAddVat = false;
                    if (country) {
                        await this.state.listOfEuAbbreviations.map(countryFromMap => countryFromMap === country ? shouldAddVat = true : '');
                    }

                    await this.setState({
                        selectedPaymentMethod: default_payment_method_for_project && default_payment_method_for_project.id ?
                            default_payment_method_for_project.id : result.data.user_payment_methods[0].id,
                        selectedPaymentMethodId: default_payment_method_for_project && default_payment_method_for_project.payment_method_id ?
                            default_payment_method_for_project.payment_method_id : result.data.user_payment_methods[0].payment_method_id,
                        shouldAddVat: country && shouldAddVat && !vatNumber ? true : false,
                    })
                    // console.log('Evo podataka: ', default_payment_method_for_project, this.state.selectedPaymentMethod, this.state.selectedPaymentMethodId)
                }
            } catch (e) {
                toastr.error("Error Code #99039: Couldn't get payment methods.")
            }
        }
        this.setState({ getPaymentMethodsLoader: false })
    }

    componentDidMount() {
        // console.log('existingPayment - this.props.location.state.discountedAmount :', this.props.location.state.discountedAmount)
        // ReactGA.initialize('UA-90436832-5', {
        //     debug: false,
        //     titleCase: false,
        //     gaOptions: {
        //         userId: getCurrentUserId()
        //     }
        // });
        this.analytics();
        let user = this.props.user;
        // {console.log('Opalio je componentDidMount: ', this.props.location.state)}
        let projectId = this.props.selectedSource ? this.props.selectedSource : localStorage.source_clicked ? JSON.parse(localStorage.source_clicked) : '';
        let project = user.sources.data.find(project => projectId.toString() === project.id.toString());
        if (project && project.default_billing_details && project.default_billing_details.address && project.default_billing_details.address.country) {
            this.state.listOfEuAbbreviations.map(country => country === project.default_billing_details.address.country ? this.setState({shouldAddVat: true}) : '');
        }
        //console.log('Project data: ', this.state.shouldAddVat, project);

        const user_id = getCurrentUserId();
        if (window.location.pathname === '/existing-payment') {
            // console.log('this.props.location.state: ', this.props.location.state)
            if (this.props.location.state && this.props.location.state.amount && this.props.location.state.stripePlanId) {
                let yearlySubscription = false;
                if (this.props.location.state.yearly && (this.props.location.state.yearly === 'yearly')) {
                    yearlySubscription = true
                }

                let upcomingSwitchPlans = '';
                if (this.props.location.state.upcomingSwitchPlans) {
                    upcomingSwitchPlans = this.props.location.state.upcomingSwitchPlans;
                }
                // console.log('existing payment props location: ', this.props.location)
                this.setState({
                    fundsAmount: this.props.location.state.amount,
                    stripePlanId: this.props.location.state.stripePlanId,
                    yearlySubscription,
                    freeTrial: this.props.location.state.freeTrial || false,
                    discountedAmount: this.props.location.state.discountedAmount ? this.props.location.state.discountedAmount : '',
                    upcomingSwitchPlans

                })
            }
            // console.log('location.state: ', this.props.location.state)
            if (!user_id && (window.location.pathname !== "/login" && window.location.pathname !== "/register")) {
                window.location = "/login";
            }
            if ((!this.props.location.state || !this.props.location.state.amount || this.props.location.state.amount === 0 || !user.customer) && !this.state.stripePlanId && !this.state.fundsAmount) {
                this.props.history.push('/subscription-plans')
            }
        }
        if (window.location.pathname === '/pay-phone-numbers-existing-payment') {
            if (this.props.location.state && this.props.location.state.amount && this.props.location.state.addedNumbers) {
                this.setState({
                    payPhoneNumbers: true,
                    fundsAmount: this.props.location.state.amount,
                    addedNumbers: this.props.location.state.addedNumbers
                })
            } else {
                this.props.history.push('/phone-numbers')
            }
        }
        if (window.location.pathname === '/topup-existing-payment') {
            let topUpLimit=this.props.selectedSourceNode && this.props.selectedSourceNode.project_balance && this.props.selectedSourceNode.project_balance.balance_threshold ?
                    parseInt(this.props.selectedSourceNode.project_balance.balance_threshold) : 0
            let topUpWith=this.props.selectedSourceNode && this.props.selectedSourceNode.project_balance && this.props.selectedSourceNode.project_balance.top_up_amount ?
                    parseInt(this.props.selectedSourceNode.project_balance.top_up_amount) : 0
            if (this.props.location.state && this.props.location.state.amount && this.props.location.state.creditsAmount) {

                this.setState({
                    fundsAmount: this.props.location.state.amount,
                    creditsAmount: this.props.location.state.creditsAmount,
                    topUpLimit,
                    topUpWith
                })
            } else {
                this.props.history.push('/top-up/add-credits')
            }
        }
        if (window.location.pathname === '/viber-subscription-existing-payment') {
            if (this.props.location.state && this.props.location.state.viberSelectedPlan) {
                let plan = this.props.location.state.viberSelectedPlan
                let fundsAmount = this.props.location.state.viberSelectedPlan === 'Region A' ? 200 : 150

                this.setState({
                    viberSelectedPlan: plan,
                    viberSelectedPlanId: plan === 'Region A' ? 'viber_region_a_usd_monthly' : 'viber_region_b_usd_monthly',
                    fundsAmount
                })
            } else {
                this.props.history.push('/viber-subscription/select-plan')
            }
        }


        this.getPaymentMethods()

    }

    payWithDefaultCard = async () => {
        //console.log('payWithDefaultCardFunc')
        let user = await this.props.user;
        let projectId = await this.props.selectedSource ? this.props.selectedSource : localStorage.source_clicked ? JSON.parse(localStorage.source_clicked) : '';
        let project = await user.sources.data.find(project => projectId.toString() === project.id.toString())
        let smsPlatform = project ? project.platforms.find(plan => plan.platform === 'sms') : '';
        let plan = smsPlatform ? smsPlatform.plan : '';
        //console.log('this project:', project)
        //console.log('this plan:', plan)
        this.setState({loader: true, paymentErrorMessage: ''})
        let useDiscount = (new Date() > new Date('11/19/2020 00:00')) && (new Date() < new Date('12/07/2020 23:59 (CET)'))
        try {
            if (project && plan) {
                // let smsPlatform = project.platforms.find(platform => platform.platform === 'sms');
                // let emitto_plan_id = smsPlatform.plan;
                //if(plan === 'emitto_free_plan'){

                const proPlanResult = await http.post('api/user/' + user.id + '/project/' + projectId + '/customers/switch_plans',
                    {
                        "plan": this.state.stripePlanId,
                        "freeTrial": this.state.freeTrial,
                        "use_discount": this.state.confirmed_promo_code ? 0 : this.state.yearlySubscription ? 1 : 0,
                        "promo_code": this.state.confirmed_promo_code
                        // "use_discount": useDiscount ? 1 : 0
                    }, {headers: {authorization: getJwt()}})
                if (proPlanResult.data.error) {
                    // Display result.error.message in your UI.
                    this.setState({loader: false});
                    toastr.error(proPlanResult.data.message)
                } else if (proPlanResult) {
                    this.props.updateUserFromServer();
                    this.setState({loader: false});
                    this.handleClearCoupon();
                    this.handleSubscriptionCompleted(this.state.stripePlanId);
                }
                // }
            } else {
                // console.log('selectPaymentMethod: ', 'api/user/' + user.id + '/project/' + projectId + '/customers/existing_payment_methods')
                const result = await http.get('/api/user/' + user.id + '/project/' + projectId + '/customers/get_payment_methods_project', {headers: {authorization: getJwt()}});
                let projectPaymentMethods = result.data.project_payment_methods;
                const selectPaymentMethod =
                    projectPaymentMethods.length ?
                        await http.post('api/user/' + user.id + '/project/' + projectId + '/customers/default_payment_method_project',
                            {"pm_id": this.state.selectedPaymentMethod}, {headers: {authorization: getJwt()}})
                        :
                        await http.post('api/user/' + user.id + '/project/' + projectId + '/customers/oa_payment_method_customer',
                            {"pm_id": this.state.selectedPaymentMethod}, {headers: {authorization: getJwt()}})
                // projectPaymentMethods.length ?
                //     await http.post('api/user/' + user.id + '/project/' + projectId + '/customers/oa_payment_method_customer',
                //         {"pm_id": this.state.selectedPaymentMethod}, {headers: {authorization: getJwt()}})
                //     :
                //     await http.post('api/user/' + user.id + '/project/' + projectId + '/customers/existing_payment_methods',
                //         {"pm_id": this.state.selectedPaymentMethod}, {headers: {authorization: getJwt()}})
                // console.log('payWithDefaultCard: ', project, selectPaymentMethod);
                // console.log('pay with default card, plan / freeTrial', this.state.stripePlanId + ' / ' + this.state.freeTrial)
                const proPlanResult = await http.post('api/user/' + user.id + '/project/' + projectId + '/customers/subscribe_to_plan', {
                    "plan": this.state.stripePlanId,
                    "freeTrial": this.state.freeTrial,
                    "use_discount": this.state.confirmed_promo_code ? 0 : this.state.yearlySubscription ? 1 : 0,
                    "promo_code": this.state.confirmed_promo_code
                    // "use_discount": useDiscount ? 1 : 0
                }, {headers: {authorization: getJwt()}})
                if (proPlanResult.data.error) {
                    // Display result.error.message in your UI.
                    await this.setState({loader: false});
                    await toastr.error(proPlanResult.data.message || proPlanResult.data.error)
                } else if (proPlanResult) {
                    this.props.updateUserFromServer();
                    this.setState({loader: false});
                    this.handleClearCoupon();
                    this.handleSubscriptionCompleted(this.state.stripePlanId);
                }
            }
        } catch (e) {
            if (e && e.error && e.error.decline_code === 'insufficient_funds') {
                this.setState({paymentErrorMessage: e.error.message})
                // toastr.error(e.error.message);
            } else {
                //console.log('failed with default card')
                toastr.error("Signing for Premium plan wasn't successful. Please try again.");
            }
            this.setState({loader: false})
        }
    }

    payWithNewCard = async () => {
        let user = await this.props.user;
        let projectId = await this.props.selectedSource ? this.props.selectedSource : localStorage.source_clicked ? JSON.parse(localStorage.source_clicked) : '';
        let project = await user.sources.data.find(project => projectId.toString() === project.id.toString());
        let smsPlatform = project ? project.platforms.find(plan => plan.platform === 'sms') : '';
        let plan = smsPlatform ? smsPlatform.plan : '';
        this.setState({loader: true, paymentErrorMessage: ''})
        let useDiscount = (new Date() > new Date('11/19/2020 00:00')) && (new Date() < new Date('12/07/2020 23:59 (CET)'))
        // console.log('payWithNewCard data: ', project, plan)

        /* For new card when upgrading from free plan, Switch Plan api call is in <CardWithDetailsSetup>Form.js */
        try {
            if (project && plan) {
                // let smsPlatform = project.platforms.find(platform => platform.platform === 'sms');
                // let emitto_plan_id = smsPlatform.plan;
                // if(plan === 'emitto_free_plan'){
                const proPlanResult = await http.post('api/user/' + user.id + '/project/' + projectId + '/customers/switch_plans', {
                    "plan": this.state.stripePlanId,
                    "freeTrial": this.state.freeTrial,
                    "use_discount": this.state.confirmed_promo_code ? 0 : this.state.yearlySubscription ? 1 : 0,
                    "promo_code": this.state.confirmed_promo_code
                    // "use_discount": useDiscount ? 1 : 0
                }, {headers: {authorization: getJwt()}})
                if (proPlanResult.data.error) {
                    // Display result.error.message in your UI.
                    this.setState({loader: false});
                    toastr.error(proPlanResult.data.message)
                    // console.log('jedan: ', proPlanResult.data)
                } else if (proPlanResult) {
                    this.setState({loader: false});
                    this.props.updateUserFromServer();
                    this.handleClearCoupon();
                    this.handleSubscriptionCompleted(this.state.stripePlanId);
                    // setProPlanSuccessModalActive(true);
                }
                if (proPlanResult) {

                }
                // }
            } else {
                const proPlanResult = await http.post('api/user/' + user.id + '/project/' + projectId + '/customers/subscribe_to_plan', {
                    "plan": this.state.stripePlanId,
                    "freeTrial": this.state.freeTrial,
                    "use_discount": this.state.confirmed_promo_code ? 0 : this.state.yearlySubscription ? 1 : 0,
                    "promo_code": this.state.confirmed_promo_code
                    // "use_discount": useDiscount ? 1 : 0
                }, {headers: {authorization: getJwt()}})
                if (proPlanResult.data.error) {
                    // Display result.error.message in your UI.
                    this.setState({loader: false});
                    toastr.error(proPlanResult.data.message || proPlanResult.data.error)
                    // console.log('jedan: ', proPlanResult.data)
                } else if (proPlanResult) {
                    this.props.updateUserFromServer();
                    this.setState({loader: false});
                    this.handleClearCoupon();
                    this.handleSubscriptionCompleted(this.state.stripePlanId);
                }
            }

        } catch (e) {
            if (e && e.error && e.error.decline_code === 'insufficient_funds') {
                this.setState({paymentErrorMessage: e.error.message})
                // toastr.error(e.error.message);
            } else {
                //console.log('failed with new card')

                toastr.error("Signing for Premium plan wasn't successful. Please try again.");
            }
            this.setState({loader: false})

        }
    }

    handlePhoneNumbersResult = (phone_numbers) => {
        let boughtNumbers = [];
        let notBoughtNumbers = [];
        let notBoughtNumbersAmount = 0;
        // console.log('phone_numbers and addedNumbers: ', phone_numbers, this.state.addedNumbers)


        phone_numbers.map(number => number.error || !number.phone_success ?
            this.state.addedNumbers.map(addedNumb => addedNumb.phoneNumber === number.phone_provided ? notBoughtNumbers = [...notBoughtNumbers, addedNumb] : '')
            :
            this.state.addedNumbers.map(addedNumb => addedNumb.phoneNumber === number.phone_provided ? boughtNumbers = [...boughtNumbers, addedNumb] : ''));

        /* this should be removed when magic number is not used any more */
        // await phone_numbers.map(number => number.error ? '' : boughtNumbers = [...boughtNumbers, {phoneNumber: number.phone_provided}])
        /* --       --         --          --            --              */

        notBoughtNumbers.map(number => notBoughtNumbersAmount = notBoughtNumbersAmount + parseInt(number.base_price));

        this.setState({
            boughtNumbers,
            notBoughtNumbers,
            payPhoneNumbersResultModalVisible: true,
            notBoughtNumbersAmount
        })
        // console.log('handlePhoneNumberResult: ', boughtNumbers, notBoughtNumbers, notBoughtNumbersAmount)
    }

    phoneNumbersPayWithDefaultCard = async () => {
        let user = await this.props.user;
        let projectId = await this.props.selectedSource ? this.props.selectedSource : localStorage.source_clicked ? JSON.parse(localStorage.source_clicked) : '';
        /* listOfPhones should be empty array when there is no need for using of magic number */
        // let listOfPhones = await [{
        //     type: 'local',
        //     phone: '+15005550006',
        //     country: 'US'
        // }];
        let listOfPhones = await [];
        await this.state.addedNumbers.map(number => listOfPhones = [...listOfPhones, {
            type: number.number_type,
            phone: number.phoneNumber,
            country: number.countryCode
        }])
        await this.setState({loader: true, paymentErrorMessage: ''})

        try {
            const result = await http.post('api/project/' + projectId + '/phones_twilio_pricing', {
                "phone_numbers": listOfPhones,
                "payment_method": this.state.selectedPaymentMethodId
            }, {headers: {authorization: getJwt()}})
            // await console.log('payWithDefaultCard: ', result.data.phone_numbers)
            // await result.data.phone_numbers.map(number=>number.error ? toastr.error('Phone number ' + number.phone_provided + " wasn't bought. Please try again.") :
            //     toastr.success("Phone number " + number.phone_provided + " was successfully bought"))
            await this.handlePhoneNumbersResult(result.data.phone_numbers)
            // await this.props.history.push('/channels')
            this.setState({loader: false})

        } catch (e) {
            if (e && e.error && e.error.decline_code === 'insufficient_funds') {
                await this.setState({paymentErrorMessage: e.error.message})
                // toastr.error(e.error.message);
            } else {
                toastr.error("Buying of the phone numbers was unsuccessful. Please try again.");
            }
            await this.setState({loader: false})
        }
    }

    phoneNumbersPayWithNewCard = async () => {
        let user = await this.props.user;
        let projectId = await this.props.selectedSource ? this.props.selectedSource : localStorage.source_clicked ? JSON.parse(localStorage.source_clicked) : '';
        // let project = await user.sources.data.find(project => projectId.toString() === project.id.toString())
        // let smsPlatform = project ? project.platforms.find(plan => plan.platform === 'sms') : '';
        // let plan = smsPlatform ? smsPlatform.plan : '';
        // let listOfPhones = await [{
        //     type: 'local',
        //     phone: '+15005550006',
        //     country: 'US'
        // }];
        let listOfPhones = await [];
        await this.state.addedNumbers.map(number => listOfPhones = [...listOfPhones, {
            type: number.number_type,
            phone: number.phoneNumber,
            country: number.countryCode
        }])
        await this.setState({loader: true, paymentErrorMessage: ''})

        let boughtNumbers = [];
        let notBoughtNumbers = [];
        try {
            const result = await http.post('api/project/' + projectId + '/phones_twilio_pricing', {
                "phone_numbers": listOfPhones,
                "payment_method": this.state.selectedPaymentMethodId
            }, {headers: {authorization: getJwt()}})
            // await console.log('payWithDefaultCard: ', result.data.phone_numbers)
            // await result.data.phone_numbers.map(number=>number.error ? toastr.error('Phone number ' + number.phone_provided + " wasn't bought. Please try again.") :
            //     toastr.success("Phone number " + number.phone_provided + " was successfully bought"))
            await this.handlePhoneNumbersResult(result.data.phone_numbers)
            // await this.props.history.push('/channels')
            this.setState({loader: false})

        } catch (e) {
            if (e && e.error && e.error.decline_code === 'insufficient_funds') {
                await this.setState({paymentErrorMessage: e.error.message})
                // toastr.error(e.error.message);
            } else {
                toastr.error("Buying of the phone numbers was unsuccessful. Please try again.");
            }
            this.setState({loader: false})
        }
    }

    handleSaveTopUp = async () => {
        /* This two requests are used after credit payment is successfull for editing Auto Top Up related values, one is for top up enabled case
        * and other is for disabled case*/
        //console.log('handle save started')
        let projectId = await this.props.selectedSource ? this.props.selectedSource : localStorage.source_clicked ? JSON.parse(localStorage.source_clicked) : '';
        if (this.state.autoTopUp) {
            try {
                let result = await http.post('api/user/' + this.props.user.id + '/project/' + projectId + '/edit_workspace_balance', {
                    balance_threshold: parseInt(this.state.topUpLimit),
                    top_up_amount: parseInt(this.state.topUpWith),
                    notify_me_by: "",//if set otherwise null
                    top_up_enabled: this.state.autoTopUp//can be set via this call as with the previous one
                }, {headers: {authorization: getJwt()}});
                // console.log('new tags:', tags);
                this.props.updateUserFromServer();
            } catch (ex) {
                toastr.error("Error with saving Auto Top Up");
                await this.setState({spinnerActive: false})
            }
        } else if (this.state.autoTopUp) {
            toastr.error("You can top up with minimum $15 and balance threshold should be at least $20.")
        }

        if (!this.state.autoTopUp) {
            // await this.setState({fieldsCheckActive: false})
            try {
                let result = await http.post('api/user/' + this.props.user.id + '/project/' + projectId + '/top_up_balance', {
                    top_up_enabled: this.state.autoTopUp//can be set via this call as with the previous one
                }, {headers: {authorization: getJwt()}});
                // console.log('new tags:', tags);
                this.props.updateUserFromServer();
            } catch (ex) {
                toastr.error("Error with saving Auto Top Up");
            }
        }
    }

    topUpPayWithDefaultCard = async () => {
        let user = await this.props.user;
        let projectId = await this.props.selectedSource ? this.props.selectedSource : localStorage.source_clicked ? JSON.parse(localStorage.source_clicked) : '';
        this.setState({loader: true, paymentErrorMessage: ''})
        if ((Number(this.state.topUpLimit) >= 1000 && Number(this.state.topUpWith) >= 1000 && this.state.autoTopUp) || !this.state.autoTopUp) {
            try {
                // console.log('selectPaymentMethod: ', 'api/user/' + user.id + '/project/' + projectId + '/customers/existing_payment_methods')
                const result = await http.get('/api/user/' + user.id + '/project/' + projectId + '/customers/get_payment_methods_project', {headers: {authorization: getJwt()}});
                let projectPaymentMethods = result.data.project_payment_methods;
                const selectPaymentMethod =
                    projectPaymentMethods.length ?
                        await http.post('api/user/' + user.id + '/project/' + projectId + '/customers/default_payment_method_project',
                            {"pm_id": this.state.selectedPaymentMethod}, {headers: {authorization: getJwt()}})
                        :
                        await http.post('api/user/' + user.id + '/project/' + projectId + '/customers/oa_payment_method_customer',
                            {"pm_id": this.state.selectedPaymentMethod}, {headers: {authorization: getJwt()}})
                // projectPaymentMethods.length ?
                //     await http.post('api/user/' + user.id + '/project/' + projectId + '/customers/oa_payment_method_customer',
                //         {"pm_id": this.state.selectedPaymentMethod}, {headers: {authorization: getJwt()}})
                //     :
                //     await http.post('api/user/' + user.id + '/project/' + projectId + '/customers/existing_payment_methods',
                //         {"pm_id": this.state.selectedPaymentMethod}, {headers: {authorization: getJwt()}})
                // console.log('payWithDefaultCard: ', project, selectPaymentMethod);
                // console.log('pay with default card, plan / freeTrial', this.state.stripePlanId + ' / ' + this.state.freeTrial)
                const topUp = await http.post('api/user/' + user.id + '/project/' + projectId + '/top_up_project', {
                    "credits": parseInt(this.state.creditsAmount)
                    // "use_discount": useDiscount ? 1 : 0
                }, {headers: {authorization: getJwt()}})

                if (topUp && topUp.data && topUp.data.success) {
                    await this.props.updateUserFromServer();
                    this.setState({loader: false});
                    toastr.success("Successful top-up!");
                    await this.handleSaveTopUp();
                    this.props.history.push('/billing/balance', {shouldUpdateUserData: true})
                } else {
                    this.setState({loader: false});
                    toastr.error("Top-up failed. Please try again or contact support.");
                }
            } catch (e) {
                //console.log('failed with default card')
                toastr.error("Top-up was unsuccessful, please try again.");
                this.setState({loader: false})
            }
        } else {
            toastr.error("You can top up with minimum 1000 credits and balance threshold should be at least 1000 credits.")
            this.setState({loader: false})
        }
    }

    viberPlanPayWithDefaultCard = async () => {
        let user = await this.props.user;
        let projectId = await this.props.selectedSource ? this.props.selectedSource : localStorage.source_clicked ? JSON.parse(localStorage.source_clicked) : '';
        this.setState({loader: true, paymentErrorMessage: ''})

        let viberSelectedPlanId = this.state.viberSelectedPlanId ? this.state.viberSelectedPlanId : process.env.REACT_APP_ENVIRONMENT === 'PROD' ?
            this.state.viberSelectedPlan === 'Region A' ? 'price_1J2xTdK5UACAN2bBBvepXFDV' : 'price_1J2xTdK5UACAN2bBOEVSgZQ6' :
            this.state.viberSelectedPlan === 'Region A' ? 'price_1J2xS0K5UACAN2bBXEps5c2l' : 'price_1J2xS0K5UACAN2bBaQMfLIkq'
        if (viberSelectedPlanId) {
            try {
                const viberPlan = await http.post('api/user/' + user.id + '/project/' + projectId + '/subscribe_to_viber_plan', {
                    "plan": viberSelectedPlanId
                }, {headers: {authorization: getJwt()}})

                if (!viberPlan.data.error) {
                    this.props.updateUserFromServer();
                    this.setState({loader: false});
                    toastr.success("Viber plan successfully purchased");
                    this.props.history.push('/channels')
                } else {
                    toastr.error(viberPlan.data.message || "Unsuccessful, please try again.");
                    this.setState({loader: false})
                }

            } catch (e) {
                //console.log('failed with default card')
                toastr.error("Unsuccessful, please try again.");
                this.setState({loader: false})
            }
        }

    }

    selectPaymentMethod = async (id, longId, country, vatNumber) => {
        // console.log('Opalio je selectPaymentMethod: ', id, longId, country, vatNumber)
        if (this.state.selectedPaymentMethod !== id) {
            this.setState({ paymentMethodLoaderId : id})
            let shouldAddVat = false;
            if (country) {
                await this.state.listOfEuAbbreviations.map(countryFromMap => countryFromMap === country ? shouldAddVat = true : '');
            }
            // if (shouldAddVat && vatNumber && country !== 'UK' && country !== 'GB'){
            // VAT valid check (vatsense)
            // try {
            //     const vatCheckResult = await axios.get('https://api.vatsense.com/1.0/validate?vat_number=GB288305674',{
            //         auth: {
            //             username: 'user',
            //             password: '4caf7d75819d9aa0e4deda330567e426'
            //         }
            //     });
            //     console.log('vatCheckResult: ', vatCheckResult);
            // }catch(e){
            //     console.log('vatCheckResult: ', e)
            // }
            // VAT valid check (apilayer)
            //     try {
            //         const vatCheckResult = await axios.get('http://www.apilayer.net/api/validate?access_key=851cc261e444128f00d313e216a4960e&vat_number=' + vatNumber);
            //         console.log('vatCheckResult: ', vatCheckResult);
            //     }catch(e){
            //         console.log('vatCheckResult: ', e)
            //     }
            // }

            let user = await this.props.user;
            let projectId = await this.props.selectedSource ? this.props.selectedSource : localStorage.source_clicked ? JSON.parse(localStorage.source_clicked) : '';
            let project = await user.sources.data.find(project => projectId.toString() === project.id.toString())
            let smsPlatform = project ? project.platforms.find(plan => plan.platform === 'sms') : '';
            let plan = smsPlatform ? smsPlatform.plan : '';
            let upcomingSwitchPlans = ''

            let useDiscount = this.state.stripePlanId.includes('yearly');
            try {
                const result = await http.get('/api/user/' + user.id + '/project/' + projectId + '/customers/get_payment_methods_project', {headers: {authorization: getJwt()}});
                let projectPaymentMethods = result.data.project_payment_methods;
                const setDefaultPM =
                    projectPaymentMethods.length ?
                        await http.post('api/user/' + user.id + '/project/' + projectId + '/customers/default_payment_method_project',
                            {"pm_id": id}, {headers: {authorization: getJwt()}})
                        :
                        await http.post('api/user/' + user.id + '/project/' + projectId + '/customers/existing_payment_methods',
                            {"pm_id": id}, {headers: {authorization: getJwt()}})
                // if (plan && (plan !== this.state.stripePlanId) && (window.location.pathname === '/existing-payment') &&
                //     (this.props.location.state && this.props.location.state.amount && this.props.location.state.planId)) {
                try {
                    const result = await http.post('/api/user/' + user.id + '/project/' + projectId + '/customers/upcoming_switch_plans', {
                        "plan": this.state.stripePlanId,
                        "use_discount": useDiscount,
                        "promo_code": ''
                    }, {headers: {authorization: getJwt()}});
                    upcomingSwitchPlans = await result.data.invoice_upcoming;
                } catch (e) {
                    // console.log('')
                }
                // }
            } catch (e) {
                toastr.error("Couldn't set default payment method, please try again")
            }


            await this.setState({
                selectedPaymentMethod: id,
                selectedPaymentMethodId: longId,
                shouldAddVat: country && shouldAddVat && !vatNumber ? true : false,
                upcomingSwitchPlans,
                paymentMethodLoaderId : ''
            })
        }

        // console.log('upcomingSwitchPlans: ', this.state.upcomingSwitchPlans)
    }

    updateWithDataFromNavigation = (data) => {
        this.setState({fundsAmount: data.amount, stripePlanId: data.stripePlanId})
        //console.log('Uradio sam update: ', this.state.fundsAmount, this.state.stripePlanId)
    }

    handleClose = () => {
        this.setState({addPaymentMethodModalActive: false})
    }

    handleSubscriptionCompleted = (planId) => {
        // console.log('planId: ', planId)
        if (planId === 'tester_monthly') {
            this.props.history.push('/tester-monthly-confirmation')
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'Pageview',
                pagePath: '/tester-monthly-confirmation',
                pageTitle: 'Tester Monthly Confirmation',
            });
        } else if (planId === 'starter_monthly') {
            this.props.history.push('/starter-monthly-confirmation')
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'Pageview',
                pagePath: '/essentials-monthly-confirmation',
                pageTitle: 'Essentials Monthly Confirmation',
            });
        } else if (planId === 'essentials_monthly') {
            this.props.history.push('/essentials-monthly-confirmation')
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'Pageview',
                pagePath: '/essentials-monthly-confirmation',
                pageTitle: 'Essentials Monthly Confirmation',
            });
        } else if (planId === 'boost_monthly') {
            this.props.history.push('/boost-monthly-confirmation')
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'Pageview',
                pagePath: '/boost-monthly-confirmation',
                pageTitle: 'Boost Monthly Confirmation',
            });
        } else if (planId === 'tester_yearly') {
            this.props.history.push('/tester-yearly-confirmation')
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'Pageview',
                pagePath: '/tester-yearly-confirmation',
                pageTitle: 'Tester Yearly Confirmation',
            })
        } else if (planId === 'starter_yearly') {
            this.props.history.push('/starter-yearly-confirmation')
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'Pageview',
                pagePath: '/starter-yearly-confirmation',
                pageTitle: 'Starter Yearly Confirmation',
            })
        } else if (planId === 'essentials_yearly') {
            this.props.history.push('/essentials-yearly-confirmation')
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'Pageview',
                pagePath: '/essentials-yearly-confirmation',
                pageTitle: 'Essentials Yearly Confirmation',
            });
        } else if (planId === 'boost_yearly') {
            this.props.history.push('/boost-yearly-confirmation')
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'Pageview',
                pagePath: '/boost-yearly-confirmation',
                pageTitle: 'Boost Yearly Confirmation',
            });
        } else {
            this.props.history.push('/subscription-confirmation')
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'Pageview',
                pagePath: '/subscription-confirmation',
                pageTitle: 'Subscription Confirmation',
            });
        }
    }

    handleApplyCoupon = async () => {
        let user = await this.props.user;
        let projectId = await this.props.selectedSource ? this.props.selectedSource : localStorage.source_clicked ? JSON.parse(localStorage.source_clicked) : '';
        this.setState({
            couponLoader: true,
        })
        // console.log('discountCode: ', this.state.discountCode, this.state.upcomingSwitchPlans)
        if (this.state.discountCode) {
            try {
                const result = await http.post('/api/user/' + user.id + '/project/' + projectId + '/customers/upcoming_switch_plans', {
                    plan: this.state.stripePlanId,
                    use_discount: 0,
                    promo_code: this.state.discountCode
                }, {headers: {authorization: getJwt()}});
                if (result && result.data && result.data.invoice_upcoming &&
                    (result.data.invoice_upcoming.invoiceEstimate && result.data.invoice_upcoming.invoiceEstimate.lineItems &&
                        result.data.invoice_upcoming.invoiceEstimate.lineItems.length &&
                    result.data.invoice_upcoming.invoiceEstimate.lineItems[0].discountAmount)
                    ||
                    (result.data.invoice_upcoming.nextInvoiceEstimate && result.data.invoice_upcoming.nextInvoiceEstimate.line_items &&
                        result.data.invoice_upcoming.nextInvoiceEstimate.line_items.length &&
                        result.data.invoice_upcoming.nextInvoiceEstimate.line_items[0].discountAmount)
                ) {
                    this.setState({
                        confirmed_promo_code: this.state.discountCode,
                        // confirmed_promo_code_percentage: result.data.invoice_upcoming.discount.coupon.percent_off,
                        couponLoader: false,
                        errorsList: [],
                        fieldsCheckActive: false,
                        upcomingSwitchPlans: result.data.invoice_upcoming
                    })
                } else {
                    this.setState({
                        couponLoader: false,
                        fieldsCheckActive: true,
                        errorsList: ['Wrong coupon. Please add a valid discount code value!'],
                        confirmed_promo_code: '',
                        confirmed_promo_code_percentage: ''
                    })
                }
            } catch (e) {
                this.setState({
                    couponLoader: false,
                    fieldsCheckActive: true,
                    errorsList: ['Wrong coupon. Please add a valid discount code value!'],
                    confirmed_promo_code: '',
                    confirmed_promo_code_percentage: ''
                })
            }
        } else {
            this.setState({
                couponLoader: false,
                fieldsCheckActive: true,
                errorsList: ["Coupon can't be empty!"],
                confirmed_promo_code: '',
                confirmed_promo_code_percentage: ''
            })
        }

    }

    handleClearCoupon = () => {
        this.setState({
            upcomingSwitchPlans: '',
            confirmed_promo_code: '',
            confirmed_promo_code_percentage: '',
            discountCode: ''
        })
    }

    updateErrorsList = async (error, id) => {
        // let errorsList = await this.state.errorsList;
        // errorsList[parseInt(id) - 1] = await error;
        // await this.setState({errorsList})
        //console.log('errorsList: ', errorsList)
    }

    render() {
        let user = this.props.user;
        let projectId = this.props.selectedSource || localStorage.source_clicked ? JSON.parse(localStorage.source_clicked) : '';
        // let project = user.sources.data.find(project => projectId.toString() === project.id.toString());
        let project = user.sources.data.length ? user.sources.data.find(source => source.id.toString() === projectId) : '';
        //let sharedProject = user.feeds_shared.data && user.feeds_shared.data.length ? user.feeds_shared.data.find(feed => feed.id.toString() === projectId) : '';
        let smsPlatform = project ? project.platforms.find(plan => plan.platform === 'sms') : '';
        let plan = smsPlatform ? smsPlatform.plan : '';
        let allPaymentMethodsExpired = false;
        let expiredCheckList = [];
        {
            this.state.paymentMethods.map(method => {
                let endDate = method.ends_at;
                let date = endDate.substring(0, 4);
                let month = endDate.substring(5, 7);
                let day = endDate.substring(8, 10);
                let today = new Date();
                let expired = new Date(date, month, day) < today;
                if (expired) {
                    expiredCheckList.push(expired)
                }
            })
        }
        if (expiredCheckList.length === this.state.paymentMethods.length) {
            allPaymentMethodsExpired = true
        } else {
            allPaymentMethodsExpired = false
        }


        return (
            <div className="add-funds-wrapper">
                <div className="top-navigation">
                    <RetinaImage src={['/img/emitto-logo.png', '/img/emitto-logo.svg']} checkIfRetinaImgExists={false}/>
                    <div className="navigation-wrapper">
                        {
                            window.location.pathname === '/topup-existing-payment' ?
                                <i className="fas fa-chevron-right"></i>
                                :
                                ''
                        }
                        <div className="menu-link">
                            {
                                window.location.pathname === '/topup-existing-payment' ?
                                    <span
                                        className={'regular'}
                                        onClick={() => this.props.history.push('/billing/preferences')}
                                    >
                                        Back to Balance
                                    </span>
                                    :
                                    ''
                            }
                            <i className="fas fa-check"></i>
                            {
                                window.location.pathname === '/topup-existing-payment' ?
                                    <span
                                        className={'regular'}
                                        onClick={() => this.props.history.push('/top-up/add-credits', {
                                            amount: this.state.fundsAmount,
                                        })}
                                    >
                                        Add Funds
                                    </span>
                                    :
                                    this.state.payPhoneNumbers ?
                                        <span
                                            className={'regular'}
                                            onClick={() => this.props.history.push('/phone-numbers', {
                                                amount: this.state.fundsAmount,
                                                addedNumbers: this.state.addedNumbers
                                            })}
                                        >
                                            Phone Numbers
                                        </span>
                                        :
                                        window.location.pathname === '/viber-subscription-existing-payment' ?
                                            <span
                                                className={'regular'}
                                                onClick={() => this.props.history.push('/viber-subscription/select-plan', {
                                                    planType: this.state.viberSelectedPlan
                                                })}
                                            >
                                                Choose Plan
                                            </span>
                                            :
                                            <NavLink to="/subscription-plans">
                                                <span className={'regular'}>Choose Plan</span>
                                            </NavLink>
                            }
                        </div>
                        <i className="fas fa-chevron-right"></i>
                        <div className="menu-link">
                            {/*<NavLink to="/existing-payment">*/}
                            <span className='blue'>Payment</span>
                            {/*</NavLink>*/}
                        </div>
                    </div>
                </div>

                <div className="main">
                    <div className='add-funds-content-container'>
                        <div className='white-wrapper'>
                            {/*{plan ?*/}
                            {/*<h2 className='page-title'><strong>Pay With a Default Payment Method</strong></h2>*/}
                            {/*:*/}
                            <h2 className='page-title'><strong>Choose a Payment Method</strong></h2>
                            {/*}*/}
                            {/*{plan ?*/}
                            {/*<p>Using default payment method</p>*/}
                            {/*:*/}
                            <p>Using an existing payment method</p>
                            {/*}*/}
                            {this.state.getPaymentMethodsLoader && (!this.state.paymentMethods || !this.state.paymentMethods.length) ?
                                <div className='get-payment-methods-loader-container'>
                                    <ChartLoader/>
                                </div>
                                :
                                ''
                            }
                            {this.state.paymentMethods.map(method => {
                                let endDate = method.ends_at;
                                let date = endDate.substring(0, 4);
                                let month = endDate.substring(5, 7);
                                let day = endDate.substring(8, 10);
                                let today = new Date();
                                let expired = new Date(date, month, day) < today;
                                // if (plan){
                                //     if (method.payment_method_id && method.project_default && !expired) {
                                //         return <SinglePaymentMethodSelect
                                //             method={method}
                                //             isActive={method.id === this.state.selectedPaymentMethod}
                                //             handleClick={() => this.selectPaymentMethod(method.id, method.payment_method_id)}
                                //         />
                                //     }
                                // } else
                                if (method.payment_method_id && !expired) {
                                    return <SinglePaymentMethodSelect
                                        method={method}
                                        isActive={method.id === this.state.selectedPaymentMethod}
                                        handleClick={() => this.selectPaymentMethod(method.id, method.payment_method_id,
                                            method.billing_details && method.billing_details.address &&
                                            method.billing_details.address.country ? method.billing_details.address.country : '',
                                            method.billing_details && method.billing_details.vat_number ?
                                                method.billing_details.vat_number : ''
                                        )}
                                        history={this.props.history}
                                        updatePaymentMethods={this.getPaymentMethods}
                                        selectedSource={this.props.selectedSource}
                                        loaderActive={this.state.paymentMethodLoaderId === method.id}

                                        // handleClick={() => this.selectPaymentMethod(method.id, method.payment_method_id,
                                        //     this.state.noProjectPaymentMethods && method.billing_details && method.billing_details.address &&
                                        //     method.billing_details.address.country ? method.billing_details.address.country : '')}
                                    />
                                }
                                //console.log('Proba proba: ', this.state.noProjectPaymentMethods, method.billingDetails, )
                            })}
                            {/*{!plan ?*/}
                            <p className='blue-text'
                               onClick={() => this.setState({addPaymentMethodModalActive: true})}>+ Add new payment
                                method</p>
                            {
                                allPaymentMethodsExpired ?
                                    <p className='blue-text'
                                       onClick={() => this.props.history.push('/billing/payment-methods')}>> Select
                                        another payment method</p>
                                    :
                                    ''
                            }
                            {/*:*/}
                            {/*''*/}
                            {/*}*/}

                            <p className='grey-text'>By clicking above, you agree to the storage of this information and
                                with the Emitto Privacy Statement.</p>
                            {
                                this.state.paymentMethods && this.state.paymentMethods.length ?
                                    <p className='discount-code'
                                       onClick={() => this.setState({showDiscountInput: !this.state.showDiscountInput})}>I
                                        have a promo code</p>
                                    :
                                    ''
                            }
                            {
                                this.state.showDiscountInput ?
                                    <div className='coupon-container'>
                                        <InputRegular
                                            id={'1'}
                                            label1=""
                                            label2=""
                                            placeholder="DISCOUNT_CODE"
                                            type='always-error'
                                            onChange={async (value) => await this.setState({
                                                discountCode: value,
                                                fieldsCheckActive: false
                                            })}
                                            value={this.state.discountCode}
                                            required={true}
                                            fieldsCheckActive={this.state.fieldsCheckActive}
                                            updateErrorsList={this.updateErrorsList}
                                            errorMessage="Wrong coupon. Please add a valid discount code value!"
                                        />
                                        {this.state.couponLoader ?
                                            <button className='blue-button-spinner' disabled={true}>Apply Coupon <i
                                                className='fa fa-spin fa-spinner'></i></button>
                                            :
                                            <button className='blue-button' onClick={this.handleApplyCoupon}>Apply
                                                Coupon</button>
                                        }
                                    </div>
                                    :
                                    ''
                            }
                            {
                                this.state.showDiscountInput && this.state.confirmed_promo_code && this.state.confirmed_promo_code_percentage ?
                                    <p className='green-text-coupon'>Promo code is confirmed</p>
                                    :
                                    ''
                            }

                            {
                                (window.location.pathname === '/topup-existing-payment') ?
                                    <div>
                                        <div className='flex-direction-row margin-top-20 margin-bottom-10'>
                                            <Switch
                                                style={{margin: 0}} checked={this.state.autoTopUp}
                                                onChange={() => this.setState({autoTopUp: !this.state.autoTopUp})}
                                            />
                                            <h3 style={{margin: 0}}>Auto Top Up</h3>
                                        </div>
                                        {this.state.autoTopUp ?
                                            <div>
                                                <p className='grey-text'>Automatically recharge your account through
                                                    your default payment method anytime your
                                                    balance runs below the listed amount.</p>
                                                <div className='flex-direction-row space-between'>
                                                    <div className='width-48'>
                                                        <InputRegular
                                                            className={this.state.autoPush ? '' : 'input-disabled'}
                                                            id="1"
                                                            label1="When Balance Falls Below"
                                                            placeholder="1000"
                                                            type='number'
                                                            valueBelow={1000}
                                                            min={1000}
                                                            disabled={!this.state.autoTopUp}
                                                            onChange={value => this.setState({
                                                                topUpLimit: value,
                                                                autoTopUpSave: true
                                                            })}
                                                            value={this.state.topUpLimit.toString()}
                                                            required={true}
                                                            fieldsCheckActive={this.state.fieldsCheckActive}
                                                            updateErrorsList={this.updateErrorsList}
                                                            errorMessage="Amount can't be less than 1000"
                                                        />
                                                    </div>
                                                    <div className='width-48'>
                                                        <InputRegular
                                                            className={this.state.autoPush ? '' : 'input-disabled'}
                                                            id="2"
                                                            label1="Top Up With"
                                                            placeholder="1000"
                                                            type='number'
                                                            valueBelow={1000}
                                                            disabled={!this.state.autoTopUp}
                                                            onChange={value => this.setState({
                                                                topUpWith: value,
                                                                autoTopUpSave: true
                                                            })}
                                                            value={this.state.topUpWith.toString()}
                                                            required={true}
                                                            fieldsCheckActive={this.state.fieldsCheckActive}
                                                            updateErrorsList={this.updateErrorsList}
                                                            min={1000}
                                                            errorMessage="Amount can't be less than 1000"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            :
                                            ''
                                        }
                                    </div>
                                    :
                                    ''
                            }

                            {this.state.loader ?
                                <button
                                    className='btn-action btn-480 margin-top-20'
                                    disabled={true}
                                >
                                    Pay With Card <i className='fa fa-spin fa-spinner'></i>
                                    {/*{plan ? 'Pay With Default Card' : 'Pay With Card' } <i className='fa fa-spin fa-spinner'></i>*/}
                                </button>
                                :
                                allPaymentMethodsExpired ?
                                    <button
                                        className='btn-action btn-480 margin-top-20'
                                        disabled={true}
                                    >
                                        Pay With Card
                                        {/*{plan ? 'Pay With Default Card' : 'Pay With Card'}*/}
                                    </button>
                                    :
                                    <button
                                        className='btn-action btn-480 margin-top-20'
                                        onClick={
                                            this.state.viberSelectedPlan ?
                                                this.viberPlanPayWithDefaultCard : this.props.topUpViber ?
                                                    this.topUpPayWithDefaultCard : this.state.payPhoneNumbers ?
                                                        this.phoneNumbersPayWithDefaultCard : this.payWithDefaultCard
                                        }
                                    >
                                        Pay With Card
                                        {/*{plan ? 'Pay With Default Card' : 'Pay With Card'}*/}
                                    </button>
                            }
                            <div className='powered-by-stripe-logo'>
                                <img src="/img/safe-checkout.png" alt=""/>
                            </div>
                        </div>
                        <AddPaymentMethodModal
                            showModal={this.state.addPaymentMethodModalActive}
                            handleClose={this.handleClose}
                            maxWidth={500}
                            project={project ? project
                                //: sharedProject ? sharedProject
                                : ''}
                            selectedSource={this.props.selectedSource}
                            history={this.props.history}
                            user={this.props.user}
                            stripePlanId={this.state.stripePlanId}
                            // subscribeToPlan={this.props.topUpViber ? this.topUpPayWithNewCard : this.state.payPhoneNumbers ? this.phoneNumbersPayWithNewCard : this.payWithNewCard}
                            newProject={project && plan ? false : true}
                            updateUserFromServer={this.props.updateUserFromServer}
                            errorMessage={this.state.paymentErrorMessage}
                            proPlanSuccessModalActive={() => this.setState({proPlanSuccessModalActive: true})}
                            dataFromNavigation={this.props.location.state}
                            updateWithDataFromNavigation={this.updateWithDataFromNavigation}
                            payPhoneNumbers={this.state.payPhoneNumbers}
                            paymentMethods={this.state.paymentMethods}
                            updatePaymentMethods={this.getPaymentMethods}
                        />
                    </div>
                    {/*{console.log('order summary check: ', this.state.shouldAddVat, this.state.fundsAmount)}*/}
                    <OrderSummary
                        orderAmount={this.state.fundsAmount}
                        vat={this.state.shouldAddVat ? parseInt(this.state.fundsAmount) * 0.2 : 0}
                        totalAmount={this.state.shouldAddVat ? parseInt(this.state.fundsAmount) + (parseInt(this.state.fundsAmount) * 0.2) : this.state.fundsAmount}
                        exclVat={0}
                        newBalance={this.state.fundsAmount}
                        withCheckout={this.state.addedNumbers.length}
                        cartListTitle={'Phone Numbers'}
                        cartListSubtitle={'Monthly Subscription'}
                        cartList={this.state.addedNumbers}
                        cartItemIdentifier={this.state.addedNumbers.length ? 'phoneNumber' : ''}
                        cartCostIdentifier={this.state.addedNumbers.length ? 'base_price' : ''}
                        disableItemRemoval={true}
                        stripePlanId={this.state.stripePlanId ? this.state.stripePlanId : ''}
                        yearlySubscription={this.state.yearlySubscription}
                        noButton={true}
                        spinner={this.state.spinnerActive}
                        discountedAmount={this.state.discountedAmount}
                        discountAmount={this.state.upcomingSwitchPlans && this.state.upcomingSwitchPlans.invoiceEstimate &&
                        this.state.upcomingSwitchPlans.invoiceEstimate.lineItems && this.state.upcomingSwitchPlans.invoiceEstimate.lineItems.length &&
                        this.state.upcomingSwitchPlans.invoiceEstimate.lineItems[0].discountAmount ? this.state.upcomingSwitchPlans.invoiceEstimate.lineItems[0].discountAmount / 100 : ''
                        }
                        upcomingSwitchPlans={this.state.upcomingSwitchPlans}
                        showViberPlanName={this.state.viberSelectedPlan}
                    />
                </div>
                {/*{console.log('Add funds object: ', this.state)}*/}

                {/*<ProPlanSuccessModal*/}
                {/*showModal={this.state.proPlanSuccessModalActive}*/}
                {/*handleClose={() => {*/}
                {/*this.setState({proPlanSuccessModalActive: false})*/}
                {/*this.props.history.push('/subscription-confirmation');*/}
                {/*}}*/}
                {/*maxWidth={500}*/}
                {/*history={this.props.history}*/}
                {/*/>*/}

                <PayPhoneNumbersResultModal
                    showModal={this.state.payPhoneNumbersResultModalVisible}
                    boughtNumbers={this.state.boughtNumbers}
                    notBoughtNumbers={this.state.notBoughtNumbers}
                    handleClose={() => this.setState({payPhoneNumbersResultModalVisible: false})}
                    handleBackToNumbers={() => this.props.history.push('/phone-numbers', {
                        amount: this.state.notBoughtNumbersAmount,
                        addedNumbers: this.state.notBoughtNumbers
                    })}
                    history={this.props.history}
                />
            </div>
        );
    }
}

export default ExistingPayment;